import { X } from "lucide-react";
import { Legend, useColors } from "./colors";

const chip = (on) => `press h-8 px-3 rounded-full border text-[13px] font-semibold whitespace-nowrap ${on ? "bg-brand-navy text-white border-brand-navy" : "bg-white hover:bg-slate-50"}`;

export const emptyFilters = { brands: [], models: [], color: "", exclude_disc: true };

export function FilterChips({ s, f, setF, view, setView }) {
  const { cats } = useColors();
  const tog = (k, v) => setF({ ...f, [k]: f[k].includes(v) ? f[k].filter((x) => x !== v) : [...f[k], v], ...(k === "brands" ? { models: [] } : {}) });
  const any = f.brands.length || f.models.length || f.color;
  return (
    <div className="space-y-2" data-testid="cassa-filter-chips">
      <div className="flex flex-wrap items-center gap-2 text-[13px]">
        <label className="flex items-center gap-1.5"><input type="checkbox" data-testid="cassa-exclude-disc" checked={f.exclude_disc} onChange={(e) => setF({ ...f, exclude_disc: e.target.checked })} className="w-4 h-4 accent-brand-navy" /> Escludi non più disponibili</label>
        <span className="flex-1" />
        {view && <>
          <div className="inline-flex rounded-md border bg-white p-0.5">{[[false, "Comoda"], [true, "Compatta"]].map(([d, l]) => (
            <button key={l} data-testid={`cassa-density-${d ? "compact" : "comfy"}`} onClick={() => setView({ dense: d })} className={`press h-7 px-2 rounded text-xs font-semibold ${view.dense === d ? "bg-brand-navy text-white" : ""}`}>{l}</button>))}</div>
          <button data-testid="cassa-text-minus" onClick={() => setView({ scale: Math.max(0.9, +(view.scale - 0.1).toFixed(1)) })} className="press h-8 w-9 rounded border bg-white text-xs font-bold">A−</button>
          <button data-testid="cassa-text-plus" onClick={() => setView({ scale: Math.min(1.4, +(view.scale + 0.1).toFixed(1)) })} className="press h-8 w-9 rounded border bg-white text-sm font-bold">A+</button>
        </>}
        <Legend />
      </div>
      <div className="flex flex-wrap gap-1.5 pb-1">
        {cats.filter((c) => c.active).map((c) => (
          <button key={c.key} data-testid={`cassa-chip-color-${c.key}`} onClick={() => setF({ ...f, color: f.color === c.key ? "" : c.key })} className={chip(f.color === c.key)}>
            <span className="inline-block w-2.5 h-2.5 rounded-full mr-1.5 align-middle" style={{ background: c.level === "fill" ? c.border : c.bg }} />{c.name}
          </button>
        ))}
        {any ? <button data-testid="cassa-chips-clear" onClick={() => setF({ ...f, brands: [], models: [], color: "" })} className="press h-8 px-2 rounded-full text-rose-600 text-[13px] font-semibold flex items-center"><X className="w-4 h-4" /> azzera</button> : null}
      </div>
      {s.brands?.length > 0 && (
        <div className="flex gap-1.5 overflow-x-auto pb-1" data-testid="cassa-brand-chips">
          <span className="text-[11px] font-mono text-slate-500 self-center shrink-0">MARCHE</span>
          {s.brands.map((b) => <button key={b.b} data-testid={`cassa-chip-brand-${b.b}`} onClick={() => tog("brands", b.b)} className={chip(f.brands.includes(b.b))}>{b.label} <span className="opacity-60">{b.n}</span></button>)}
        </div>
      )}
      {f.brands.length > 0 && s.models?.length > 0 && (
        <div className="flex gap-1.5 overflow-x-auto pb-1" data-testid="cassa-model-chips">
          <span className="text-[11px] font-mono text-slate-500 self-center shrink-0">MODELLI</span>
          {s.models.map((m) => { const id = `${m.b}|${m.k}`; return <button key={id} data-testid={`cassa-chip-model-${m.k}`} onClick={() => tog("models", id)} className={chip(f.models.includes(id))}>{m.label} <span className="opacity-60">{m.n}</span></button>; })}
        </div>
      )}
    </div>
  );
}
